/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-02
 *
 **/

import {httpClientBackend, httpClient} from "./http-client";
import {procedureListRequest, procedureCountStatusRequest, procedureAutocompleteRequest} from "./../api/models";



/**
 * Obtiene las coincidencias del autocomplete
 * @param field_id
 * @param stage_id
 * @param query
 * @returns {Promise<AxiosResponse<any>>}
 */
 const getAutoCompleteApi = (request = procedureAutocompleteRequest()) => 
    httpClientBackend.get(`/get_data_autocomplete?field_id=${request.field_id}&stage_id=${request.stage_id}&query=${request.query}`)


/**
 * Obtiene el listado de tramites realizados por el usuario, pudiendo filtrar por estatus
 *
 * @param request
 * @returns {Promise<AxiosResponse<any>>}
 */
const getListByUser = (request = procedureListRequest()) =>
    httpClientBackend.get(`/tramites_usuario/${request.status}`, {
        params: {page: request.page, limit: request.limit, invited: request.invited, session_user: request.sessionUser}
    })

/**
 * Obtiene el conteo de tramites por cada estatus
 *
 * @param userId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getStatusCount = (request = procedureCountStatusRequest()) =>
    httpClientBackend.get(`/tramites_usuario_count/${request.userId}/${request.sessionUser}/${request.invited}`)

/**
 * Inicializa un nuevo tramite
 *
 * @param processId, el tipo de tramite que se necesita inicializar
 * @returns {Promise<AxiosResponse<any>>}
 */
const getStartNew = (processId, invited, sessionUser) =>
    httpClient.get(`tramite_iniciar/${processId}/${invited}/${sessionUser}`)

/**
 * Obtienes el listado de pasos de una tarea
 *
 * @param taskId
 * @param stageId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getTaskSteps = (taskId, stageId) =>
    httpClientBackend.get(`tareas/${taskId}/pasos?stage_id=${stageId}`)

/**
 * Obtiene valores dinammicos para los campos de tipo Select en el formulario
 *
 * @param stageId
 * @param fieldId
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
const getFormSelectValues = (stageId, fieldId, params) => httpClientBackend.get(`get_values_select/${stageId}/${fieldId}/1?${params}`)


/**
 * Ejecuta la url de siguiente y atras del formulario del tramite
 *
 * @param url
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const postExecuteForm = (url, data) => httpClient.post(url, data)

/**
 * Ejecuta la url de siguiente y atras del formulario del tramite
 *
 * @param url
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getExecuteForm = (url) => httpClient.get(url)

/**
 * Realiza la continuación de un trámite
 *
 * @param stageId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getContinueStage = (stageId) => httpClient.get(`etapa_ejecutar/${stageId}/0`)

/**
 * Realiza la continuación del trámite en modo Vista
 *
 * @param stageId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getViewStage = (stageId) => httpClient.get(`etapa_ver/${stageId}/0`)

/**
 * Obtiene el resultado de ejecutar el boton de tipo submit
 *
 * @param stageId
 * @param fieldId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getSubmitRequest = (stageId, fieldId) =>
    httpClientBackend.get(`send_request?stage_id=${stageId}&field_id=${fieldId}`)

const getApiAjaxResult = (request) => httpClientBackend.get('ajax_get_data', {params: request})

export {
    getListByUser,
    getStatusCount,
    getStartNew,
    getFormSelectValues,
    getTaskSteps,
    getContinueStage,
    getViewStage,
    postExecuteForm,
    getExecuteForm,
    getSubmitRequest,
    getApiAjaxResult,
    getAutoCompleteApi
}
